module.exports = __webpack_public_path__ + "img/layout-text-sidebar-reverse.2f399684.svg";